<kuv-alert></kuv-alert>
<kuv-loading></kuv-loading>

<div class="container-fluid p-5">
    <h3>Gestión de Proveedor</h3>
    <button class="btn btn-primary my-2" (click)="agregar()"><i class="fas fa-plus-circle me-2"></i>Registrar Nuevo
        Proveedor</button>
    <br>
    <kuv-lazy-table [url]="config.apiUrl + 'proveedor/index/'" [pageSize]="20" [reloadEmitter]="reloadEmitter"
        [headers]="sesion.headers" [urlExcel]="config.apiUrl + 'proveedor/excel'" [headersBlob]="sesion.headersBlob"
        [filtros]="filtros" [columnas]="columnas" [acciones]="acciones" [useIndex]="true" [isRounded]="true"
        [hasShadow]="true"></kuv-lazy-table>
</div>